import {DatePipe} from '@angular/common';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CalendarEvent, CalendarEventAction} from 'angular-calendar';
import {Slot} from '../classes/Slot';
import {map} from 'rxjs/operators';
import {EventColor} from 'calendar-utils';
import {environment} from '../../environments/environment';

// TODO create separate service to convert DatePeriod data to CalendarEvents with colors
const colors: Record<string, EventColor> = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  grey: {
    primary: '#7b7676',
    secondary: '#bbbbb4',
  },
};

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class SlotService {

  constructor(private httpClient: HttpClient, private datePipe: DatePipe) {}

  getBookedDatePeriodsForRoom(roomId: number, startDate: Date, endDate: Date): Observable<CalendarEvent[]> {
    const calendarEvents: CalendarEventAction[] = [];

    const roomParam = 'roomId=' + roomId;

    let dateParam: string;
    dateParam = 'startDate=' + startDate.toISOString() + '&endDate=' + endDate.toISOString();

    return this.httpClient
      .get<Slot[]>(`${environment.backendApiUrl}/v1/slots/booked?` + roomParam + '&' + dateParam, httpOptions)
      .pipe(
        map((orders) =>
          orders.map<CalendarEvent>((slot: Slot) => ({
            title: 'Booked time',
            start: new Date(slot.start),
            end: new Date(slot.end),
            color: {...colors.grey},
            actions: calendarEvents,
            resizable: {
              beforeStart: false,
              afterEnd: false,
            },
            draggable: false,
          }))
        )
      );
  }
}
